<template>
  <div>
    <v-dialog
      max-width="1000px"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      v-model="previewDialogOpened"
      @keydown.esc="
        previewDialogOpened = false;
        documentPreviewData = '';
        previewRotation = 0;
      "
    >
      <v-card v-if="selectedDocumentLink && previewType">
        <v-card-title class="title">
          <span class="text-truncate" style="max-width: 600px">{{
            getDocumentName(selectedDocumentLink)
          }}</span>

          <v-spacer />
          <v-tooltip bottom class="mr-1">
            <v-btn
              fab
              small
              flat
              class="white primary--text text-capitalize ma-0"
              @click="previewRotation += 90"
              slot="activator"
            >
              <v-icon size="25"> rotate_right </v-icon>
            </v-btn>
            <span>Rotate</span>
          </v-tooltip>
          <v-btn
            fab
            small
            flat
            class="white error--text text-capitalize ma-0 ml-1"
            @click="
              previewDialogOpened = false;
              documentPreviewData = '';
              previewRotation = 0;
            "
          >
            <v-icon size="25"> clear </v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text v-if="documentPreviewData && previewLoaded">
          <preview-document
            :document-preview-data="documentPreviewData"
            :preview-type="previewType"
            :preview-rotation="previewRotation"
          />
        </v-card-text>
        <v-card-text v-else>
          <v-progress-circular
            indeterminate
            size="50"
            class="primary--text ma-5"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <input
      type="file"
      style="display: none"
      ref="selectedDocuments"
      multiple
      @change="onDocumentsPicked"
    />
    <upload-dialog
      :opened.sync="uploadDialogOpened"
      :documents-to-import="documentsToImport"
      @add-file="addFile"
      @pick-documents="pickDocuments()"
      @import-documents="importDocuments()"
      :selected-question="selected"
    />
    <v-dialog
      width="800"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      v-model="opened"
      scrollable
      persistent
      @keydown.esc="$emit('handle-close-entry-dialog')"
      @keydown.enter="$emit('update:opened', false)"
      lazy
    >
      <v-card
        flat
        v-if="clientEntryQuestions && clientEntryQuestions.length > 0"
      >
        <v-card-title class="client-entrty-dialog__title">
          <sx-flex :is-column="true" :gap="12">
            <!-- Title -->
            <sx-h5>
              <v-layout
                align-center
                v-if="selectedSection && selectedSection.customTabHeader"
              >
                {{ selectedSection.customTabHeader }}
              </v-layout>
              <v-layout v-else>
                {{ isNewClientEntry ? 'Add New ' : 'Edit '
                }}{{ selectedSection ? selectedSection.itemName : 'Entry' }}
              </v-layout>
            </sx-h5>

            <!-- Tabs -->
            <v-tabs
              v-model="active"
              color="white"
              slider-color="primary"
              class="mb-2"
              v-if="selectedSection && selectedSection.sections"
            >
              <v-tab
                v-for="(section, i) in filteredSections"
                :key="i"
                ripple
                class="text-none"
                active-class="primary--text"
              >
                {{ section.name }}
              </v-tab>
            </v-tabs>
          </sx-flex>
        </v-card-title>
        <v-card-text class="client-entrty-dialog__content">
          <!-- Alerts -->
          <v-alert
            v-if="
              selectedSubSection && !isEmpty(selectedSubSection.description)
            "
            :value="true"
            outline
            block
            :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
            color="primary"
            class="text-xs-left mb-4"
          >
            {{
              findFirmTabDescription(selectedSection, selectedSubSection)
                ? findFirmTabDescription(selectedSection, selectedSubSection)
                : selectedSubSection.description
            }}
          </v-alert>

          <!-- Content -->
          <v-layout column :key="i" v-for="(field, i) in filteredFields">
            <v-divider
              v-if="
                i !== 0 &&
                  ((selectedSubSection &&
                    selectedSubSection.groupQuestions &&
                    !isEmpty(findQuestionGroup(field))) ||
                    findQuestion(field))
              "
            />
            <v-layout
              v-if="
                selectedSubSection &&
                  selectedSubSection.groupQuestions &&
                  !isEmpty(findQuestionGroup(field))
              "
              row
              class="my-2"
            >
              <v-flex
                xs4
                :key="y"
                v-for="(question, y) in findQuestionGroup(field)"
                class="mx-1"
              >
                <div class="text-xs-left">{{ question.text }}</div>
                <v-radio-group
                  row
                  hide-details
                  v-model="question.answer"
                  v-if="question.question_type === 'boolean'"
                  class="mx-0 my-1 pa-0"
                >
                  <v-radio label="Yes" value="Yes"></v-radio>
                  <v-radio label="No" value="No"></v-radio>
                </v-radio-group>
                <v-text-field
                  v-if="question.question_type === 'text'"
                  v-model="question.answer"
                  placeholder="Answer"
                  class="default-input"
                  solo
                  :rules="
                    question.number_of_characters
                      ? [rules.chars(question.number_of_characters)]
                      : []
                  "
                  :counter="!!question.number_of_characters"
                  :maxlength="question.number_of_characters"
                  :hide-details="!question.number_of_characters"
                />
                <v-textarea
                  v-else-if="question.question_type === 'textarea'"
                  v-model="question.answer"
                  class="default-input"
                  solo
                  hide-details
                />
                <sensitive-type-input
                  v-else-if="question.question_type === 'password'"
                  :question="question"
                  v-model="question.answer"
                />
                <v-text-field
                  v-else-if="question.question_type === 'date'"
                  type="date"
                  v-model="question.answer"
                  class="default-input"
                  solo
                  hide-details
                />
                <v-select
                  v-else-if="question.question_type === 'select'"
                  v-model="question.answer"
                  :items="question.options"
                  placeholder="Choose an option"
                  class="default-input"
                  solo
                  hide-details
                />
                <v-select
                  v-else-if="question.question_type === 'multiple'"
                  :value="answerToList(question)"
                  @input="changeSelected(question)"
                  @change="saveAnswer"
                  :items="question.options"
                  class="default-input"
                  placeholder="Choose one or more options"
                  solo
                  multiple
                  chips
                  small-chips
                  hide-details
                />

                <v-layout
                  v-else-if="question.question_type === 'upload'"
                  column
                >
                  <!-- List of files -->
                  <div
                    v-for="(document, i) in listDocuments(question.answer)"
                    :key="`question_${i}`"
                    class="questionnaire-question__uploaded-file"
                  >
                    <!-- File name -->
                    <a @click="previewDocument(document)">
                      <sx-flex :gap="6" :is-y-centered="true">
                        <div class="questionnaire-question__file_icon">
                          <sx-icon
                            name="file"
                            :size="20"
                            color="currentcolor"
                          />
                        </div>
                        <span>{{ getDocumentName(document) }}</span>
                      </sx-flex>
                    </a>

                    <!-- Delete file -->
                    <div
                      v-if="!disableAnswerChange"
                      @click="deleteDocument(question, document)"
                    >
                      <sx-button-group>
                        <sx-button type="error" size="micro">
                          <sx-icon name="close" :size="14" />
                        </sx-button>
                      </sx-button-group>
                    </div>
                  </div>

                  <!-- File upload button -->
                  <div
                    @click="openUploadDocumentDialog(field)"
                    class="questionnaire-question__upload mt-2 mb-4"
                  >
                    <sx-button
                      type="primary"
                      size="small"
                      :isDisabled="documentsLoading"
                    >
                      <v-layout v-if="documentsLoading" align-center>
                        <v-progress-circular
                          indeterminate
                          size="20"
                          color="white"
                        ></v-progress-circular>
                      </v-layout>
                      <v-layout v-else>
                        <sx-icon name="file-upload" :size="20" />
                      </v-layout>
                      {{ $t('questionnaire.upload') }}
                    </sx-button>
                  </div>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout class="py-2" v-else-if="findQuestion(field)">
              <v-flex xs6 md5 align-start class="client-entry-dialog__item">
                <GlossaryTextHighlight
                  :is-small="true"
                  :text="findQuestion(field).text"
                  :firm-glossary="firmGlossary"
                />
              </v-flex>
              <v-flex
                xs6
                md4
                :md7="isEmpty(findQuestion(field).prior_year_value)"
              >
                <v-radio-group
                  row
                  hide-details
                  v-model="findQuestion(field).answer"
                  v-if="findQuestion(field).question_type === 'boolean'"
                  class="mx-0 my-1 pa-0"
                >
                  <v-radio label="Yes" value="Yes"></v-radio>
                  <v-radio label="No" value="No"></v-radio>
                </v-radio-group>
                <v-text-field
                  v-if="findQuestion(field).question_type === 'text'"
                  :value="findQuestion(field).answer"
                  placeholder="Answer"
                  class="default-input"
                  solo
                  :rules="
                    findQuestion(field).number_of_characters
                      ? [rules.chars(findQuestion(field).number_of_characters)]
                      : []
                  "
                  :counter="!!findQuestion(field).number_of_characters"
                  :maxlength="findQuestion(field).number_of_characters"
                  :hide-details="!findQuestion(field).number_of_characters"
                  @input="updateValue($event, field)"
                />
                <v-textarea
                  v-else-if="findQuestion(field).question_type === 'textarea'"
                  :value="findQuestion(field).answer"
                  class="default-input"
                  solo
                  hide-details
                  @input="updateValue($event, field)"
                />
                <sensitive-type-input
                  v-else-if="findQuestion(field).question_type === 'password'"
                  :question="findQuestion(field)"
                  :value="findQuestion(field).answer"
                  @input="updateValue($event, field)"
                />
                <v-text-field
                  v-else-if="findQuestion(field).question_type === 'date'"
                  type="date"
                  v-model="findQuestion(field).answer"
                  class="default-input"
                  solo
                  hide-details
                />
                <v-select
                  v-else-if="findQuestion(field).question_type === 'select'"
                  v-model="findQuestion(field).answer"
                  :items="findQuestion(field).options"
                  placeholder="Choose an option"
                  class="default-input"
                  solo
                  hide-details
                />
                <v-select
                  v-else-if="findQuestion(field).question_type === 'multiple'"
                  :value="answerToList(findQuestion(field))"
                  @input="changeSelected(findQuestion(field))"
                  @change="saveAnswer"
                  :items="findQuestion(field).options"
                  class="default-input"
                  placeholder="Choose one or more options"
                  solo
                  multiple
                  chips
                  small-chips
                  hide-details
                />

                <v-layout
                  v-else-if="findQuestion(field).question_type === 'upload'"
                  column
                >
                  <!-- List of files -->
                  <div
                    v-for="(document, i) in listDocuments(
                      findQuestion(field).answer,
                    )"
                    :key="`field_${i}`"
                    class="questionnaire-question__uploaded-file"
                  >
                    <!-- File name -->
                    <a @click="previewDocument(document)">
                      <sx-flex :gap="6" :is-y-centered="true">
                        <div class="questionnaire-question__file_icon">
                          <sx-icon
                            name="file"
                            :size="20"
                            color="currentcolor"
                          />
                        </div>
                        <span>{{ getDocumentName(document) }}</span>
                      </sx-flex>
                    </a>

                    <!-- Delete file -->
                    <div
                      v-if="!disableAnswerChange"
                      @click="deleteDocument(findQuestion(field), document)"
                    >
                      <sx-button-group>
                        <sx-button type="error" size="micro">
                          <sx-icon name="close" :size="14" />
                        </sx-button>
                      </sx-button-group>
                    </div>
                  </div>
                  <!-- Upload button -->
                  <div
                    @click="openUploadDocumentDialog(field)"
                    class="questionnaire-question__upload mt-2 mb-4"
                  >
                    <sx-button
                      type="primary"
                      size="small"
                      :is-disabled="loadingDocumentsHolder.includes(field.id)"
                    >
                      <v-layout
                        v-if="loadingDocumentsHolder.includes(field.id)"
                        align-center
                      >
                        <v-progress-circular
                          indeterminate
                          size="20"
                          color="white"
                        ></v-progress-circular>
                      </v-layout>
                      <v-layout v-else>
                        <sx-icon :size="20" name="file-upload" />
                      </v-layout>
                      {{ $t('questionnaire.upload') }}
                    </sx-button>
                  </div>
                </v-layout>

                <v-layout
                  class="hidden-md-and-up text-xs-left py-2 px-2"
                  v-if="!isEmpty(findQuestion(field).prior_year_value)"
                >
                  <div>
                    <span class="grey--text">Prior year value: </span>
                    <span>{{ findQuestion(field).prior_year_value }}</span>
                  </div>
                </v-layout>
              </v-flex>

              <v-flex
                md3
                class="hidden-sm-and-down text-xs-left px-4"
                v-if="!isEmpty(findQuestion(field).prior_year_value)"
              >
                <div class="grey--text"><span>Prior year value:</span></div>
                <div>
                  <span>{{ findQuestion(field).prior_year_value }}</span>
                </div>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-text>

        <!-- Actions -->
        <v-card-actions class="client-entrty-dialog__actions">
          <sx-button-group x-align="center" :is-full-width="true">
            <div v-if="hasTabs && active > 0" @click="active = active - 1">
              <sx-button type="secondary">
                <sx-icon size="16" name="arrow-left" />
                {{ $t('Back') }}
              </sx-button>
            </div>
            <div @click="saveAndExit">
              <sx-button type="primary" :is-disabled="isNextDisabled">
                <sx-icon size="16" name="check" v-if="!hasMoreTabs" />
                {{ hasMoreTabs ? $t('Next') : $t('Save') }}
                <sx-icon size="16" name="arrow-right" v-if="hasMoreTabs" />
              </sx-button>
            </div>
            <div
              @click="
                $emit('handle-close-entry-dialog', completedAtLeastOneTab)
              "
            >
              <sx-button type="secondary">
                {{ $t('Cancel') }}
              </sx-button>
            </div>
          </sx-button-group>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import API from '@/api';
import get from 'lodash/get';
import has from 'lodash/has';
import { mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import SensitiveTypeInput from '@/components/SensitiveTypeInput';
import {
  supportedExtensionsForPreview,
  customSections,
} from '@/constants/variables';
import { JOIN_STRING } from '@/constants/questionnaires';
import GlossaryTextHighlight from '../GlossaryTextHighlight';
import UploadDialog from '@/components/dialogs/UploadDialog';
import PreviewDocument from '@/components/PreviewDocument';
import debounce from 'lodash/debounce';
import SxSmall from '@/components/sx/SxSmall';
import SxH5 from '@/components/sx/SxH5';
import SxButton from '@/components/sx/SxButton';
import SxButtonGroup from '@/components/sx/SxButtonGroup';
import SxIcon from '@/components/sx/SxIcon';
import SxFlex from '@/components/sx/SxFlex';
import UtilsMixins from '@/mixins/UtilsMixins';

export default {
  components: {
    SensitiveTypeInput,
    GlossaryTextHighlight,
    UploadDialog,
    PreviewDocument,
    SxSmall,
    SxIcon,
    SxFlex,
    SxButton,
    SxButtonGroup,
    SxH5,
  },

  mixins: [UtilsMixins],

  props: {
    currentQuestionnaire: {
      type: Object,
    },
    currentSection: {
      type: Object,
    },
    opened: {
      type: Boolean,
    },
    currentCompany: {
      type: Object,
    },
    currentCompanyId: {
      type: Number,
    },

    clientEntryQuestions: {
      type: Array,
      default: null,
    },

    parentQuestion: {
      type: Object,
    },

    isNewClientEntry: {
      type: Boolean,
    },

    preview: {
      type: Boolean,
      default: false,
    },

    firmGlossary: {
      type: Array,
      default: [],
    },

    entryLoading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      customSections,
      supportedExtensionsForPreview,
      documentsLoading: false,
      documentsDeleting: false,
      active: 0,
      uploadDialogOpened: false,
      previewDialogOpened: false,
      previewLoaded: false,
      documentPreviewData: null,
      previewRotation: 0,
      selectedDocumentLink: null,
      previewType: null,
      documentsToImport: [],
      selectedSection: {
        sections: [],
      },
      selected: null,
      debouncedUpdate: null,
      loadingDocumentsHolder: [],
    };
  },

  computed: {
    ...mapGetters({
      currentUser: 'user',
      currentFirm: 'currentFirm',
    }),

    isNextDisabled() {
      return (
        (!!this.preview && !this.hasMoreTabs) ||
        this.isEntryBlank ||
        this.entryLoading
      );
    },

    filteredSections() {
      return this.selectedSection.sections.filter(subsection => {
        return this.clientEntryQuestions.some(q =>
          subsection.fields.includes(q.text),
        );
      });
    },

    hasTabs() {
      const numberOfTabs =
        (this.selectedSection && this.filteredSections.length) || 0;

      return Boolean(numberOfTabs);
    },

    hasMoreTabs() {
      const numberOfTabs =
        (this.selectedSection && this.filteredSections.length) || 0;

      return (
        this.isNewClientEntry &&
        this.hasTabs &&
        !(this.active + 1 === numberOfTabs)
      );
    },

    completedAtLeastOneTab() {
      return this.isNewClientEntry && this.hasTabs && this.active > 0;
    },

    sectionName() {
      if (this.currentSection) {
        return this.currentSection.name;
      }
    },

    isEntryBlank() {
      return this.clientEntryQuestions.every(q => isEmpty(q.answer));
    },

    selectedSubSection() {
      if (this.selectedSection) {
        return this.filteredSections[this.active];
      }
    },

    missingQuestions() {
      if (this.selectedSection && this.clientEntryQuestions) {
        let list = [];
        let addressedFields = this.selectedSection.sections
          .map(s => s.fields)
          .flat();
        this.clientEntryQuestions.forEach(item => {
          if (
            !addressedFields
              .map(f => f.toLowerCase())
              .includes(item.text.toLowerCase()) &&
            item.text.slice(-3, -1) !== ' #'
          ) {
            list = list.concat(item.text);
          }
        });
        return list;
      } else {
        return [];
      }
    },

    filteredFields() {
      if (
        this.selectedSection &&
        this.selectedSubSection &&
        this.selectedSubSection.fields
      ) {
        if (this.selectedSubSection.name.toLowerCase().includes('expense')) {
          return this.selectedSubSection.fields.concat(
            this.missingQuestions.filter(q => q.includes('Other (')),
          );
        } else {
          if (this.selectedSubSection.name.toLowerCase().includes('general')) {
            return this.selectedSubSection.fields.concat(
              this.missingQuestions.filter(q => !q.includes('Other (')),
            );
          } else {
            return this.selectedSubSection.fields;
          }
        }
      } else {
        return this.clientEntryQuestions;
      }
    },
  },

  methods: {
    isEmpty,
    pascalCaseToSnakeCase(str) {
      return str
        .match(
          /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g,
        )
        .map(x => x.toLowerCase())
        .join('_');
    },
    findFirmTabDescription(section, subsection) {
      return get(
        this.currentFirm,
        `preferences.${this.pascalCaseToSnakeCase(
          section.name,
        )}_${this.pascalCaseToSnakeCase(subsection.name)}_description`,
        false,
      );
    },
    endsWithAny(suffixes, string) {
      return suffixes.find(function(suffix) {
        return string.toLowerCase().endsWith(suffix);
      });
    },
    updateValue(value, field) {
      this.debouncedUpdate(value, field);
    },
    async previewDocument(documentLink) {
      this.previewType = '';
      this.previewLoaded = false;
      this.documentPreviewData = '';
      this.selectedDocumentLink = documentLink;
      this.previewRotation = 0;
      this.previewType = this.endsWithAny(
        this.supportedExtensionsForPreview,
        documentLink,
      );
      if (this.previewType) {
        if (this.previewType === 'pdf') {
          this.currentPage = 1;
          this.pdfLoaded = false;
        }
        this.previewDialogOpened = true;
        try {
          const response = await API.integration.downloadDocument({
            companyId: this.currentCompany.id,
            link: this.currentCompany.upload_link.concat('/', documentLink),
          });

          if (response.data.document) {
            this.documentPreviewData = response.data.document.data.link;
          } else {
            console.log(response.data.error);
            this.$store.dispatch('application/setErrorNotification', {
              message: 'There was a problem downloading the document.',
              errorToSend: response.data.error,
            });
          }
        } catch (e) {
          console.log(e);
          this.$store.dispatch('application/setErrorNotification', {
            message: 'There was a problem downloading the document.',
            errorToSend: e,
          });
        } finally {
          this.previewLoaded = true;
        }
      } else {
        this.downloadDocumentByLink(
          this.documentPreviewData,
          this.getDocumentName(documentLink),
        );
        // this.$store.dispatch('application/setErrorNotification', {
        //   message: 'Preview is not available.'
        // });
      }
    },
    async downloadDocumentByLink(url, name) {
      let response = await this.$http.get(url, { responseType: 'arraybuffer' });
      let blob = new Blob([response.data], {
        type: this.get(response.headers, 'content-type'),
      });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = name;
      link.click();
    },
    openUploadDocumentDialog(field) {
      this.uploadDialogOpened = true;
      this.documentsToImport = [];
      this.selected = this.findQuestion(field);
    },
    getNameWithoutExtensionOfFilename(filename) {
      let splitName = filename.split('.');
      splitName.pop();
      return splitName.join('.');
    },
    getExtensionOfFilename(filename) {
      return filename.split('.').pop();
    },
    async onDocumentsPicked(e) {
      const documents = e.target.files;
      if (documents) {
        const documentType = this.selectedDocumentType;
        this.documentsToImport.push(
          ...Array.from(documents).map(document => {
            return {
              name: documentType
                ? `${this.getNameWithoutExtensionOfFilename(
                    document.name,
                  )} (${documentType})`
                : this.getNameWithoutExtensionOfFilename(document.name),
              data: document,
              extension: this.getExtensionOfFilename(document.name),
            };
          }),
        );
      }
    },
    async addFile(e) {
      const documents = e.dataTransfer.files;
      if (documents) {
        const documentType = this.selectedDocumentType;
        this.documentsToImport.push(
          ...Array.from(documents).map(document => {
            return {
              name: documentType
                ? `${this.getNameWithoutExtensionOfFilename(
                    document.name,
                  )} (${documentType})`
                : this.getNameWithoutExtensionOfFilename(document.name),
              data: document,
              extension: this.getExtensionOfFilename(document.name),
            };
          }),
        );
      }
    },
    async asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    },
    startDocumentUpload() {
      this.loadingDocumentsHolder.push(this.selected.id);
    },
    markDocumentLoaded() {
      const questionIndex = this.loadingDocumentsHolder.indexOf(
        this.selected.id,
      );
      this.loadingDocumentsHolder.splice(questionIndex, 1);
    },
    async importDocuments() {
      this.documentsLoading = true;
      let path = '';
      let answer = this.selected.answer || '';
      if (this.preview) {
        this.$store.dispatch('application/setErrorNotification', {
          message: 'Upload is disabled in preview mode.',
        });
        this.uploadDialogOpened = false;
        this.documentsLoading = false;
        return;
      }

      this.startDocumentUpload();

      try {
        this.uploadDialogOpened = false;
        if (this.currentQuestionnaire.is_open_item) {
          path = `${this.currentQuestionnaire.tax_year}/${this.currentQuestionnaire.formatted_name}`;
        } else {
          if (isEmpty(this.currentQuestionnaire.document_path)) {
            path = '';
          } else {
            path = this.currentQuestionnaire.document_path
              .replace('{year}', this.currentQuestionnaire.tax_year)
              .replace('{section}', this.parentQuestion.section)
              .replace('{questionnaire_name}', this.currentQuestionnaire.name);
          }
        }

        await this.asyncForEach(
          this.documentsToImport,
          async documentToImport => {
            const trueExtension = await this.getTrueExtension(
              documentToImport.data,
            );
            const extensionsToCheck = ['pdf', 'png', 'gif', 'jpeg'];

            if (documentToImport.data.size === 0) {
              throw new Error(
                `We were unable to process some of uploaded files as they appear to be EMPTY. Kindly check those files and try uploading them again.`,
              );
            }

            if (
              extensionsToCheck.includes(documentToImport.extension) &&
              trueExtension !== documentToImport.extension
            ) {
              throw new Error(
                `We were unable to process some of uploaded files as they appear to be INVALID. Kindly check those files and try uploading them again.`,
              );
            }

            if (documentToImport.extension === 'pdf') {
              if (await this.pdfHasPassword(documentToImport.data)) {
                throw new Error(
                  `The PDFs you uploaded are password-protected. Please either remove the password or upload alternative files.`,
                );
              }
            }

            const {
              data: { id, upload_link },
            } = await API.integration.getTemporaryUploadLink({
              companyId: this.currentCompanyId,
            });

            await API.integration.uploadToDropbox(
              upload_link,
              documentToImport.data,
            );

            const section = this.currentQuestionnaire.sections.find(
              section => section.id === this.selected.section_id,
            );

            const response = await API.integration.processDocument({
              id,
              documentName:
                documentToImport.name + '.' + documentToImport.extension,
              companyId: this.currentCompanyId,
              path: '/'.concat(path),
              questionnaireId: this.currentQuestionnaire.id,
              tags: section ? [section.name] : [],
            });

            if (response.data.error) {
              console.log(response.data.error);
            } else if (response.data.is_duplicate) {
              this.$store.dispatch('application/setErrorNotification', {
                message: `The document ${documentToImport.name} has already been uploaded before. Thus, you don't need to upload it again.`,
              });
            } else {
              let list = response.data.document_location.split('/');
              list.splice(0, 3);
              answer += JOIN_STRING.concat(list.join('/'));
            }
          },
        );
        const question = this.clientEntryQuestions.find(
          q => q.id === this.selected.id,
        );
        question.answer = answer;
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: has(e, 'message')
            ? get(e, 'message')
            : 'There was a problem uploading the documents.',
          errorToSend: e,
          userEmail: this.currentUser.email,
        });
      } finally {
        this.markDocumentLoaded();
        this.documentsLoading = false;
      }
    },
    pickDocuments() {
      const input = this.$refs.selectedDocuments;
      input.type = 'text';
      input.type = 'file';
      this.$refs.selectedDocuments.click();
    },
    saveAnswer(value) {
      this.selected.answer = value.join(JOIN_STRING);
      this.$emit('save-question', this.selected);
    },
    answerToList(question) {
      if (question.answer) {
        return question.answer.replaceAll('"', '').split(JOIN_STRING);
      } else {
        return [];
      }
    },
    changeSelected(question) {
      this.selected = question;
    },
    getDocumentName(document) {
      return document.split('/')[document.split('/').length - 1];
    },
    async deleteDocument(question, document) {
      if (!this.documentsDeleting) {
        this.documentsDeleting = true;
        try {
          const response = await API.integration.deletePath({
            path: '/'.concat(document),
            companyId: this.currentCompany.id,
          });
          if (response.data.error) {
            console.log(e);
          } else {
            if (question.answer.split(JOIN_STRING).length === 1) {
              question.answer = '';
            } else {
              question.answer = question.answer
                .split(JOIN_STRING)
                .filter(d => d !== document)
                .join(JOIN_STRING);
            }
          }
        } catch (e) {
          console.log(e);
        } finally {
          this.documentsDeleting = false;
        }
      }
    },
    listDocuments(answer) {
      if (!isEmpty(answer)) {
        return answer.split(JOIN_STRING).slice(1);
      } else {
        return [];
      }
    },
    findQuestion(field) {
      if (this.selectedSection) {
        return this.clientEntryQuestions.find(
          a => a.text.toLowerCase() === field.toLowerCase(),
        );
      } else {
        return field;
      }
    },
    findQuestionGroup(field) {
      if (this.selectedSection) {
        return this.clientEntryQuestions.filter(
          a => a.text.slice(-3) === field,
        );
      } else {
        return field;
      }
    },
    async saveAndExit() {
      if (this.isNextDisabled) return;

      if (this.hasMoreTabs) {
        this.active = this.active + 1;
      } else {
        this.$emit('update:opened', false);
      }

      // Do nothing for previews
      if (this.preview) return;

      // Save everything
      const response = await API.questionnaire.saveEntries({
        questions: this.clientEntryQuestions.map(q => ({
          id: q.id,
          answer: q.answer,
          answer_by: q.answer_by,
        })),
        questionnaireId: this.currentQuestionnaire.id,
        companyId: this.currentCompanyId,
      });

      const parentQuestion =
        response && response.data && response.data.parent_question;

      if (parentQuestion) {
        this.$emit('update-parent-question-of-entries', parentQuestion);
      }
    },
  },

  watch: {
    opened: {
      handler(value) {
        if (value) {
          let specialSection = this.customSections.find(
            s => s.name === this.sectionName,
          );
          if (!specialSection) {
            specialSection = this.customSections.find(s =>
              s.otherNames.includes(this.sectionName),
            );
          }
          this.selectedSection = specialSection;
          this.active = 0;
        } else {
          this.active = 0;
        }
      },
    },
  },

  created() {
    this.debouncedUpdate = debounce((value, field) => {
      this.findQuestion(field).answer = value;
    }, 300);
  },
};
</script>

<style scoped="true">
.client-entrty-dialog__title,
.client-entrty-dialog__content {
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
}

.client-entrty-dialog__content {
  position: relative;

  box-shadow: inset 0 2px 0 0 rgba(0, 0, 0, 0.05),
    inset 0 -2px 0 0 rgba(0, 0, 0, 0.05);
}

.client-entry-dialog__item {
  margin-right: 16px;

  text-align: left;
}

/* NOTE @chris To be componentized - duplicated to be safe. */
.questionnaire-question__uploaded-file {
  display: flex;
  justify-content: space-between;
  gap: 4px;
  padding: 6px;
  max-width: 100%;
  margin-bottom: 1px;

  background-color: var(--blue-100);
  border-radius: 4px;
}

.questionnaire-question__uploaded-file a {
  color: var(--blue-500);

  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-align: left !important;
  word-break: break-all;
}

.questionnaire-question__file_icon {
  align-items: center;
  display: flex;
  height: 32px;
  justify-content: center;
  min-width: 32px;
  padding-left: 4px;
  width: 32px;

  border-radius: 4px;
  background-color: var(--gray-100);
  color: var(--blue-500);
}

.questionnaire-question__file_icon div {
  margin: 0 !important;
}

.questionnaire-question__upload {
  display: flex;
}
</style>
